import { div, label, option, select, span } from '@srfnstack/fntags'

export const ALL_IMAGE_PROVIDERS = [
  { value: 'bfl_flux2pro', label: 'Flux 2 Pro (default)' },
  { value: 'gemini', label: 'Gemini Image Pro' }
]

export const MOCKUP_IMAGE_PROVIDERS = ALL_IMAGE_PROVIDERS

export const ModelSelector = ({ model, providers }) =>
  div({ class: 'form-control' },
    label({ class: 'label' },
      span({ class: 'label-text font-bold text-xs uppercase opacity-50' }, 'Image Model')
    ),
    select({
      class: 'select select-bordered select-sm w-full',
      onchange: (e) => model(e.target.value)
    },
    providers.map(p =>
      option({
        value: p.value,
        selected: model.bindAttr(m => m === p.value)
      }, p.label)
    ))
  )
